import { normalizeUnicode } from 'pdfjs-dist';
import { memo, useEffect, useRef } from 'react';

import { removeNullCharacters } from '../../../utils/removeNullCharacters';

/**
 * This is an empty element rendered at the end of the text layer.
 * It's used to improve text selection
 */
export const PDFPageTextLayerEnd = memo(() => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = containerRef.current;

    const onMouseDown = () => {
      containerRef.current?.classList.add('active');
    };

    const onCopy = (event: ClipboardEvent) => {
      event.preventDefault();
      event.stopPropagation();

      const selection = document.getSelection();
      if (!selection) return;
      try {
        event.clipboardData?.setData('text/plain', removeNullCharacters(normalizeUnicode(selection.toString())));
      } catch (e) {
        console.error('Failed to copy text', e);
      }
    };

    const onPointerUp = () => {
      containerRef.current?.classList.remove('active');
    };

    const onSelectionChange = () => {
      const selection = document.getSelection();
      if (!selection || selection.rangeCount === 0) {
        containerRef.current?.classList.remove('active');
        return;
      }
    };

    element?.addEventListener('mousedown', onMouseDown);
    element?.addEventListener('copy', onCopy);
    element?.addEventListener('pointerup', onPointerUp);
    element?.addEventListener('selectionchange', onSelectionChange);

    return () => {
      element?.removeEventListener('mousedown', onMouseDown);
      element?.removeEventListener('copy', onCopy);
      element?.removeEventListener('pointerup', onPointerUp);
      element?.removeEventListener('selectionchange', onSelectionChange);
    };
  }, []);

  return <div className="pdfEndOfContent" ref={containerRef} />;
});

PDFPageTextLayerEnd.displayName = 'PDFPageTextLayerEnd';
